const DEMO_CALL_CONFIG_BY_COUNTRY = {
  in: {
    apiUrl: process.env.REACT_APP_DEMO_CALL_API_IN,
    assistantId: process.env.REACT_APP_OUTBOUND_CALL_ASSISTANT_ID,
    fromNumber: process.env.REACT_APP_OUTBOUND_CALL_FROM,
    apiKey: process.env.REACT_APP_OUTBOUND_CALL_API_KEY,
  },
  at: {
    apiUrl: process.env.REACT_APP_DEMO_CALL_API_AT,
    assistantId: process.env.REACT_APP_OUTBOUND_CALL_ASSISTANT_ID_AT,
    fromNumber: process.env.REACT_APP_OUTBOUND_CALL_FROM_AT,
    apiKey: process.env.REACT_APP_OUTBOUND_CALL_API_KEY_AT,
  },
};

export const COUNTRY_DIAL_CODES = {
  at: "+43",
  in: "+91",
};

function getDemoCallConfig(countryCode) {
  return DEMO_CALL_CONFIG_BY_COUNTRY[countryCode] || null;
}

export function getDemoCallApi(countryCode) {
  return getDemoCallConfig(countryCode)?.apiUrl || null;
}

export function formatE164(countryCode, rawPhone) {
  const dial = COUNTRY_DIAL_CODES[countryCode] || COUNTRY_DIAL_CODES.at;
  const digits = String(rawPhone || "").replace(/\D/g, "");
  if (!digits) return null;
  return `${dial}${digits}`;
}

export function validatePhone(countryCode, rawPhone) {
  const digits = String(rawPhone || "").replace(/\D/g, "");
  if (!digits) return "Enter your phone number";
  const minDigits = countryCode === "in" ? 10 : countryCode === "at" ? 9 : 7;
  if (digits.length < minDigits) return "Enter a valid phone number";
  return null;
}

export async function initiateDemoCall(phoneNumber, countryCode = "at") {
  const config = getDemoCallConfig(countryCode);
  if (!config?.apiUrl) {
    throw new Error("Demo call is not configured for this region.");
  }

  const { apiUrl, assistantId, fromNumber, apiKey } = config;
  if (!assistantId || !fromNumber) {
    throw new Error("Demo call is not configured (missing assistant/from).");
  }
  if (!apiKey) {
    throw new Error("Demo call is not configured (missing API key).");
  }

  const res = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-API-KEY": apiKey,
    },
    body: JSON.stringify({
      assistant_id: assistantId,
      from_number: fromNumber,
      to_number: phoneNumber,
    }),
  });

  let data = null;
  try {
    data = await res.json();
  } catch {
    /* non-JSON body */
  }

  if (!res.ok) {
    const message =
      data?.detail ||
      data?.message ||
      data?.error ||
      "Could not start the demo call. Please try again.";
    throw new Error(
      typeof message === "string" ? message : JSON.stringify(message),
    );
  }

  return data;
}
